export const LIBRARY_IMAGE_ASSETS_REFRESH_EVENT = "library:image-assets-refresh";

export const notifyLibraryImageAssetsChanged = () => {
  window.dispatchEvent(new CustomEvent(LIBRARY_IMAGE_ASSETS_REFRESH_EVENT));
};
